import { CampaignTypeEnum, ChannelEnum } from "./enums";

const SMS_DEFAULTS: Partial<Record<CampaignTypeEnum, string>> = {
  [CampaignTypeEnum.Voucher]:
    "Your {VoucherName} is available. Use it before it expires.",
  [CampaignTypeEnum.Point]:
    "Your {MemberPointBalanceExpiring} points are expiring soon. Use them before they expire.",
  [CampaignTypeEnum.VoucherPoint]:
    "Enjoy your vouchers and points. Use them before they expire.",
  [CampaignTypeEnum.EVoucher]:
    "Get more value with our e-voucher bundle. Limited time offer.",
  [CampaignTypeEnum.Custom]:
    "Enjoy your available rewards on your next visit. Use them before they expire.",
};

const WHATSAPP_DEFAULTS: Partial<Record<CampaignTypeEnum, string>> = {
  [CampaignTypeEnum.Voucher]:
    "<p>Something’s waiting for you 🎁</p><br /><p>Hi <strong>{FirstName} {LastName}</strong>,</p><br /><p>Don’t miss out on your Voucher!</p><br /><p>You have vouchers available in your account</p><ul><li><strong>{VoucherName}</strong>, will expire on <strong>{VoucherExpiry}</strong></li></ul><br /><p>Reward Applicable Services:</p>{RedemptionOrderTagsDisplayName}",
  [CampaignTypeEnum.Point]:
    "<p>Something’s waiting for you 👋</p><br /><p>Hi <strong>{FirstName} {LastName}</strong>,</p><br /><p>Don’t let your points go to waste! They’ll expire soon</p><br /><p>You have <strong>{MemberPointBalanceExpiring} Points</strong> expiring on <strong>{MemberPointBalanceNextExpiryDate}</strong>.</p><br /><p>✅ Redeem anytime before expiry</p><p>✅ Enjoy your benefit while it lasts</p>",
  [CampaignTypeEnum.VoucherPoint]:
    "<p>Something’s waiting for you 👋</p><br /><p>Hi <strong>{FirstName} {LastName}</strong>,</p><br /><p>Don’t miss out on your rewards before they expire.</p><br /><p>You have rewards available — combine them to enjoy even more savings!</p><ul><li>Your <strong>{VoucherName}</strong> will expire on <strong>{VoucherExpiry}</strong>.</li><li>Your <strong>{MemberPointBalanceExpiring} Points</strong> expiring on <strong>{MemberPointBalanceNextExpiryDate}</strong>.</li></ul><br /><p>✅ Redeem anytime before expiry</p><p>✅ Enjoy your benefit while it lasts</p>",
  [CampaignTypeEnum.EVoucher]:
    "<p>A little treat for you 🎁</p><br /><p>Hi <strong>{FirstName} {LastName}</strong>,</p><br /><p>Treat yourself or share the joy with friends with our brand new e-vouchers:</p><ul><li><strong>{EVoucherName}</strong> - available at <strong>{EVoucherPrice}</strong>.</li></ul><br /><p>Grab yours now and enjoy big savings. T&Cs apply. Don’t miss out — limited time only!</p>",
  [CampaignTypeEnum.Custom]:
    "<p>A little treat for you 🎁</p><br /><p>Hi <strong>{FirstName} {LastName}</strong>,</p<br /><p>Don’t miss out on your rewards before they expire.</p><br /><p>You have rewards available in your account — use them to enjoy even more savings!</p><ul><li>You have <strong>{MemberBalanceVoucher} Voucher(s)</strong> available to use.</li><li>You have <strong>{MemberPointBalance} Points</strong> available to use.</li></ul><br /><p>✅ Redeem anytime before expiry</p><p>✅ Enjoy your benefit while it lasts</p>",
};

export function getDefaultMessage(
  campaignType: CampaignTypeEnum | number | undefined,
  channel: ChannelEnum | null,
): string {
  if (!campaignType || !channel) return "";

  if (channel === ChannelEnum.WhatsAppStandard) {
    return WHATSAPP_DEFAULTS[campaignType as CampaignTypeEnum] ?? "";
  }

  if (channel === ChannelEnum.Sms) {
    return SMS_DEFAULTS[campaignType as CampaignTypeEnum] ?? "";
  }

  return "";
}
